export default __webpack_public_path__ + "static/serpa-a6edaf47b41beb300cb6f1f1d3da5402.svg";